import { render, staticRenderFns } from "./CuringRule.vue?vue&type=template&id=5e3e9582&scoped=true&"
import script from "./CuringRule.vue?vue&type=script&lang=js&"
export * from "./CuringRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e9582",
  null
  
)

export default component.exports